import { Stack, styled } from "@mui/material";

export const Center = styled(Stack)({
  height: "100%",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}) as typeof Stack;
